<template>
<div @keydown.ctrl.90="$store.undo($event)" tabindex="0" id="main-tree">

    <div class="menu" v-if="$store.claims.dialogs & 2 && $store.claims.phrases & 2">
        <div class="row">
            <div class="col s12" style="display:flex;align-items:center;">
        <label>
            <input type="checkbox" class="filled-in" v-model="displaySecondaryLanguage"/>
            <span>Inspection view</span>
        </label>
        <label style="margin-left:15px">
            <input type="checkbox" class="filled-in" @change="changeDragOption($event)" v-model="$store.moveDialog" ref="moveCheck"/>
            <span>Move dialog on drag</span>
        </label>
        <label style="margin-left:15px">
            <input type="checkbox" class="filled-in" @change="changeReorderOption($event)" v-model="$store.reorder" ref="reorderCheck" />
            <span>Reorder Dialogs</span>
        </label>
        <label style="margin-left:15px">
            <input type="checkbox" class="filled-in" v-model="$store.searchState" />
            <span>Search State</span>
        </label>
        <button class="btn btn-primary" style="margin-left:15px" :disabled="Object.keys($store.unsavedChangesInRoot).length == 0" @click="updateDataPackages()">Save Changes</button>
        <div v-show="displaySecondaryLanguage" style="width: 20%; display:inline-block; margin-left:2rem">
            <select v-model="secondaryLanguage">
            <option v-if="$store.languages.length > 0" value="" disabled selected>Choose a language</option>
            <option v-if="$store.languages.length == 0">No languages were found</option>
            <option v-for="(language,index) in $store.languages" :key="index" v-bind:value="language.id">{{language.name}}</option>
            </select>
        </div>
        </div>
    </div>

    </div>
    <div class="row" v-show="!initialLoad">
      <div class="col s12">
      <div class="card search-input-list-wrapper" >
      <div style="display:flex">  
      <input type="text" placeholder="Search" v-on:keyup="showSuggestions($event)" v-on:keyup.enter="renderSearchResult(false)" ref="searchInput" v-model="searchQuery" :disabled="searchInputDisabled" required />
      <button v-on:click="renderDefaultSearch()" class="search-button tooltipped" data-position="top" data-tooltip="Reload Dialog Tree" ><i  class="material-icons">restore</i></button>
      </div>
        <div class="search-suggestion-wrapper">
        <Spinner v-if="loadingSuggestions && !initialLoading" :size="'tiny'" style="margin:5px" />
        <ul v-else class="suggestion-list">
          <!-- <li v-for="(suggestion,index) in searchSuggestion" :key="index" @click="renderSearchResult(true,suggestion)" @mouseover="changeInputFieldValue(suggestion)">{{suggestion}}</li> -->
          <li v-for="(suggestion,index) in searchSuggestion" :key="index" @click="renderSearchResult(true,suggestion)" >{{suggestion}}</li>
        </ul>
        </div>
      </div>
      </div>
    </div>
    <div class="row">
        <div class="col s12">
            <div class="card" >

              <div class="row" v-if="addRoot && $store.claims.dialogs & 2 && $store.claims.phrases & 2">
                <div class="col s12">
                  <div class="card search-input-list-wrapper" >
                    <div style="display:flex">  
                      <input type="text" placeholder="Enter Name for the New Root" v-model="newRootName"  ref="searchInput2" required />
                      <button @click="cancelAddRoot()" class="search-button" ><i style="color:cadetblue" class="material-icons">reply</i></button>
                      <button @click="addNewRoot()" class="search-button" ><i style="color: teal;" class="material-icons">save</i></button>
                    </div>
                  </div>
                </div>
              </div>

                <ul v-show="!loading" class="browser-default dialog-tree-row" >
                  <li v-if="!addRoot && $store.claims.dialogs & 2 && $store.claims.phrases & 2" @click="addRootOption()" style="height: 34px;background-color:lightgrey;display:flex">
                    <i style="margin-right: 10px;margin-left: 3px;color: teal;margin-top: 4px;" class="material-icons">view_list</i> 
                  <p style="margin-top: 4px;    margin-left: 6px;font-weight: 800;color: cadetblue;font-family: monospace">Add New Root/Instance</p>
                  </li>
                    <TreeItem v-if="!$store.dialogTreeSearch" v-for="(dialog, index) in nextDialogs" :key="index" :itemNumber="''" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage"  :dialog="dialog" :parentOpen="true" :depth="0"/>
                    <TreeItem v-if="$store.dialogTreeSearch" v-for="(dialog, index) in searchRoot" :key="index" :itemNumber="''" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage"  :dialog="dialog" :parentOpen="true" :depth="0"/>
                </ul>
                <div v-if="loading">
                    <h4 class="center-align">Loading dialog editor...</h4>
                    <Spinner class="center"/>
                </div>
            </div>
        </div>
    </div>
    <Modal
        v-if="$store.deleteRoot"
        :actions="deleteRootActions"
        :content="'Entire content(if any) of the Root dialog will be deleted. Are you sure you want to delete the Root?'"
        :header="'Warning'"
      />
      
    <UploadImage v-if='$store.showUploadImageDialog && $store.claims.dialogs & 2 && $store.claims.phrases & 2'/>
    <DialogAuthorisationView v-if='$store.showAuthorisationView' @click="openAuthorisationView()"/>
	<DialogInstanceView v-if='$store.showDialogInstanceView'/>														  

</div>
</template>
<style scoped>
#main-tree{
min-height:100vh;
outline:none;
}
.dialog-tree-row {
  list-style-type: none;
  padding-left: 1em;
}
.card {
  padding: 1em;
}
.center {
  position: relative;
  left: 50%;
}
.btn-small {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  padding: 0 1rem;
  margin-bottom: 2px;
}

.center {
  position: relative;
  left: 50%;
  margin-top: 5%;
}

.menu {
  background-color: #ffffff;
  margin-bottom: 1em;
  border-bottom: #ddd solid 1px;
  padding: 0.5em 0.75rem;
  min-height: 70px;
  line-height: 3em
}

.menu input {
  width: 30%;
  border-radius: 1px;
  border: 1px solid #d9d9d9;
  border-top: 1px solid #c0c0c0;
  font-size: 14px;
  height: 2em;
  padding: 1px 8px;
}

.menu input:focus {
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  border: 1px solid #4d90fe;
  outline: none;
  width: 50%;
}

.row {
  margin-bottom: 0 !important;
}
.search-button{
  border:0px;
  background: inherit;
}
.search-button:hover{
  cursor: pointer;
}
.search-suggestion-wrapper{
  background: white;
  box-shadow: 1px 1px 3px dimgray;
}
.suggestion-list{
  margin:0px;
}
.suggestion-list li{
  padding:10px 5px;
}
.suggestion-list li:hover{
  cursor: pointer;
  background:#efefef;
}
.search-input-list-wrapper{
  display:flex;
  flex-direction: column;
}
</style>
<script>
/**
 * View for displaying a dialog tree
 */
import TreeItem from "../components/TreeItem";
import Spinner from "../components/Spinner";
import UploadImage from "../components/UploadImage";
import DialogAuthorisationView from "../components/DialogAuthorisationView"
import axios from 'axios';
import Modal from "../components/Modal";
import DialogInstanceView from "../components/DialogInstanceView";																  

export default {
  name: "dialogTree",
  components: { TreeItem, Spinner, UploadImage,DialogAuthorisationView,Modal,DialogInstanceView},
  data() {
    return {
      searchRoot: [],
      nextDialogs: {},
      newRootName:"",
      addRoot: false,
      open: false,
      root:{},
      loading: true,
      displaySecondaryLanguage: false,
      secondaryLanguage: "",
      defaultNext :[],
      rootDialogId:"",
      cancelSource:null,
      initialLoad:true,
      searchSuggestion:[],
      loadingSuggestions:false,
      initialLoading:true,
      searchInputDisabled:false,
      searchQuery:'',
      searchResultRendered:false,
      deleteRootActions: {
        Yes: () => {
          this.loading = true
          this.deletingRoot()
          this.$store.deleteRoot = false
        },
        No: () => {
          this.$store.deleteRoot = false
        }
      },
    };
  },
	mounted(){
    this.$store.unsavedChangesInRoot = {};
    var elems = document.querySelectorAll('.tooltipped');
    var instances = M.Tooltip.init(elems, {});

    if(this.$store.dialogTreeSearch){
      this.$store.dialogTreeSearch = false
    }
    this.$store.phrases = [];
    M.FormSelect.init(document.querySelectorAll("select"), {});
  },
  beforeRouteLeave(to, from, next) {
    if (Object.keys(this.$store.unsavedChangesInRoot).length > 0) {
      M.toast({ html: "Save changes", classes: "red" });
    } else {
      next();
    }
  },
	methods: {
    updateDataPackages(){
      var text = "Changes Pushed for following Nodes : "
      for(var node in this.$store.unsavedChangesInRoot){
        text = text + node + ", ";
        var update = {
          message: "Saved from dialog tree",
          instance: "start_" + node,
          update_for_device: false
        };
        this.$http.post("/settings/dataupdate", update);
      }
      text = text.slice(0, -2);
      M.toast({"html":text,"classes":"green", "displayLength":10000});
      this.$store.unsavedChangesInRoot = {};
    },
    rootDirectoryOpenClose(){
      open = !open
    },
  showSuggestions(event){
      if(event.key == 'Enter'){
         return;
      }
      if(this.initialLoading){
        this.initialLoading=false;
      }
      this.loadingSuggestions=true;
      var searchQuery =  this.searchQuery;
      var rootDialog = this.nextDialogs[this.rootDialogId];
      if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
      }
      this.cancelSource = axios.CancelToken.source();
      if(searchQuery.length==0){
        this.loadingSuggestions=false;
        this.searchSuggestion=[];
        return;
      }
     this.$http.get('search/searchbar?text=' + searchQuery + '&lang_id='+this.$store.preferredLanguage +'&dialog_type=category,question,instruction', {
        cancelToken: this.cancelSource.token,
        headers: {
          type:'dialog'
        }
      }).then((r) => {
          if (r) {
            this.cancelSource = null;
            this.searchSuggestion = r.data.length ? r.data: ["No search result."];
          }
          this.loadingSuggestions=false;
        }, err => {});
  }, 
  renderSearchResult(suggestionUsed,text) {
    this.$store.dialogTreeSearch = true
     if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
        this.cancelSource = null;
        this.loadingSuggestions=false;
      }
    this.searchSuggestion = [];
    var exactMatch;
    if(suggestionUsed){
       exactMatch = true;
       this.searchQuery = text;
    }else{
      exactMatch = false;
      text = this.searchQuery;
    }
     var rootDialog = this.searchRoot[0];
     this.loading = true;
     this.searchInputDisabled=true;
     this.$http.get('search/dialogtree?text='+ text + '&lang_id='+this.$store.preferredLanguage + '&is_exactmatch=' + exactMatch + '&dialog_type=category,question,instruction', {
       headers:{
         type:'dialog'
       }
     }).then(r=>{
       this.searchInputDisabled=false;
       var searchResultNext = [];
       if(r.data == null)
          r.data = [];
       r.data.forEach(dialog=>{
          searchResultNext.push(dialog);
       })
       this.$store.dialogTreeSearch = true
      this.searchRoot = searchResultNext;
      this.searchResultRendered = true;
      this.loading=false;
     })
  },
  renderDefaultSearch(){
  this.cancelSource = null;
  this.searchSuggestion = [];
  this.searchResultRendered = false;
  if(!this.$store.dialogTreeSearch || (this.searchQuery == "" && !this.$store.dialogTreeSearch))
    return;
   this.loading = true; 
   this.searchQuery = "";
   this.$store.dialogTreeSearch = false
   var rootDialog = this.nextDialogs[this.rootDialogId];
   rootDialog.next = this.defaultNext;
   var vm = this;
   setTimeout(function(){
     vm.loading = false;
   },1000);   
  },
  changeInputFieldValue(text){
    this.searchQuery = text;
  },
  changeDragOption(event){
  if(this.$store.reorder==true)
  this.$refs.reorderCheck.click();
  if(event.target.checked)
  this.$store.moveDialog=true;
  else
  this.$store.moveDialog=false;
  },
  changeReorderOption(event){
  if(this.$store.moveDialog==true)
  this.$refs.moveCheck.click();
  if(event.target.checked)
  this.$store.reorder=true;
  else
  this.$store.reorder=false;
  },
  cancelAddRoot(){
    this.addRoot = false
  },
  addRootOption(){
    this.addRoot = true
  },
  addNewRoot(){
    if(this.newRootName.indexOf(" ") >= 0){
      M.toast({
            html: "Spaces are not allowed in Name"
          })
      return
    }
    if(this.newRootName != ""){
    var tag = "start_"+ this.newRootName 
    var rootObj = {
      "id":"45c7c6b9",
      "phrase": this.newRootName,
      "grid":"",
      "type":"",
      "tags":[tag,"start"],
      "attachments":null,
      "imagemappingfront":"",
      "imagemappingback":"",
      "parent":null,
    }
    this.loading = true
    this.$http.post("/dialogs/00/root",rootObj).then(
      response => {
        if(!response.data.status){
          M.toast({"html":response.data.error_message,"classes":"red"});
          this.loading = false;
          return;
        }
        this.getDialogByTag("start")
        this.addRoot = false;
        this.loading = false;
      });
    }else{
      M.toast({
            html: "Name cannot be empty"
          })
    }
  },
  deletingRoot(){
    var dialog = this.$store.currentDialog
    this.loading = true;
    return new Promise((resolve, reject) => {
        this.$http.delete("/dialogs/" + dialog.id).then(
          response => {
            this.nextDialogs = {}
            this.getDialogByTag("start")
            this.loading = false;
            resolve();
          },
          response => {
            reject(response);
            this.loading = false;
          }
        );
      });
  },
    /**
     * Retrieves dialogs based on a tag
     * @param {any} tag Tag to use for query
     */
    getDialogByTag(tag) {
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs?tag=" + tag).then(
          response => {
          if(response.data && response.data[0] && response.data[0].next)  
          response.data[0].next.forEach((element)=>{
          this.$set(this.$store.dialogParent,element,response.data[0].id);
          })
            response.data.forEach(element => {
              if (!element.next) element.next = [];
              this.$set(this.nextDialogs, element.id, element);
              this.rootDialogId = element.id;
              this.defaultNext = element.next;
              this.initialLoad=false;
            });
            resolve();
          },
          response => {
            reject(response);
          }
        );
      });
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogUpdate(dialog) {
      var index
      this.$store
        .putDialog(dialog)
        .then(() => {
          this.searchRoot.forEach(element => {
            if(element.id == dialog.id){
              index = this.searchRoot.indexOf(element)
            }
            this.$set(this.searchRoot, index, dialog);
          });
        })
        .catch(() =>
          M.toast({
            html: "Could not update dialog"
          })
        );
    },
  },

  created() {
    this.$on("update:dialog", d => this.handleDialogUpdate(d));
     this.getDialogByTag("start")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
  },
  updated() {
    var elems = document.querySelectorAll('.tooltipped');
    var instances = M.Tooltip.init(elems, {});
    M.FormSelect.init(document.querySelectorAll("select"), {});
  }
};
</script>
